export default {
    enter_master_password: "zadejte hlavní heslo",
    please_enter_master_password: "prosím zadejte hlavní heslo",
    store_password_permanently: "uložit heslo permanentně do prohlížeče",
    set_master_password: "nastavit hlavní heslo",
    wipe_master_password: "vymazat hlavní heslo",
    domain_or_url: "doména nebo url",
    add_domain_to_list: "přidat doménu do seznamu",
    password_successfully_copied: "heslo úspěšně zkopírováno do schránky",
    copy_password_failed: "heslo se nepodařilo zkopírovat do schránky",
    copy_password_action_title: "zkopírovat heslo pro doménu {1} do schránky",
    remove_domain_action_title: "smazat doménu {1}",
    show_password_action_title: "zobrazit heslo pro doménu {1}",
    domain_deleted: "doména {1} smazána",
    invalid_domain: "neplatná doména",
    domain_added: "doména {1} přidána",
    domain_already_added: "doména {1} již byla přidána",
    undo: "zpět",
    current_style_is: "současný styl: {1}",
    style_changed_to: "styl změněn na: {1}",
    current_language_is: "současný jazyk: {1}",
    language_changed_to: "jazyk změněn na: {1}",
    password_for: "heslo pro doménu {1}:",
    close: "zavřít",
    one_key_to_rule_them_all: "jeden klíč vládne všem...",
    select_language: 'vyberte jazyk:',
    select_style: 'vyberte styl:',
    read_more: 'číst více...',
    show_tools: 'ukázat nástroje...',
    about_singularkey: 'více informací o aplikaci singularkey.net',
    main_doc: 'singularkey.net je bezdatabázová klíčenka na hesla. ' +
              'Pomocí jednoho tajného klíče (hesla) můžete vytvořit celou ' +
              'řadu odvozených nezávislých klíčů (hesel). Oproti klasickým ' +
              'klíčenkám není potřeba si nijak pamatovat hesla k dílčím službám ' +
              'a hesla z klíčenky jsou tak dostupná jenom na základě znalosti ' +
              'hlavního hesla.',
    main_algorithm_doc: 'Výpočet odvozených hesel probíhá pomocí algoritmu SingularKey který ' +
              'zajišťuje celé aplikaci bezpečnost. Algoritmus je otevřený a dobře zdokumentovaný, ' +
              'což umožňuje auditovatelnost celého řešení a zároveň implementaci dalších nástrojů ' +
              'realizujících tento systém klíčenky.',
    tools_doc: 'K dispozici jsou také další nástroje pracující s algoritmem SingularKey.'
}
